import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class MedicationRequestBoxService {
  constructor(private http: HttpClient) {}
  
  private hasPatientDispensedBoxesUrl: string = 'api/AdminPspMedicationRequestBox/HasPatientDispensedBoxesForProgram';
  
  hasPatientDispensedBoxes(subscriptionId: number): Observable<GenericResponse<boolean>> {
    return this.http.get<GenericResponse<boolean>>(
      `${this.hasPatientDispensedBoxesUrl}/${subscriptionId}`
    );
  }
}